import { roles } from "./roles";

// Fallback until getPowerBiRoles() responds; names come from the shared roles constants.
export const KNOWN_ROLES: string[] = [
  roles.admin,
  roles.managingDirector,
  roles.executiveLeadership,
  roles.readOnly,
  roles.Auditor,
  roles.ceo,
  roles.factorymanager,
  roles.managerPurchaseGC,
  roles.commercialHod,
  roles.managerCommerical,
  roles.commercialExecutive,
  roles.managerfinance,
  roles.Chairman,
  roles.gcStoresExecutive,
  roles.productionplanning,
  roles.generalUser,
  roles.srManager,
  roles.qcManager,
  roles.qcHead,
  roles.ProductionManager,
  roles.factoryPackingManager,
];

// sessionStorage keys that keep the catalogue's filters when the user opens a report and comes back.
export const POWER_BI_STORAGE_KEYS = {
  company: "pbiAdminCompany",
  status: "pbiAdminActive",
};

// Company-filter value meaning "every company".
export const ALL_COMPANIES = "All";

// Power BI is CCL-only for now: company fields default to this and are locked. Set to null to bring back company choice.
export const POWER_BI_LOCKED_COMPANY: string | null = "CCL";

// sessionStorage key that keeps the Dashboard page's company filter while the user moves around.
export const DASHBOARD_COMPANY_STORAGE_KEY = "dashboardCompany";

export const POWER_BI_GRID_ID = "power_bi_admin_grid_";

// requestType the shared audit log / notes tabs file Power BI rows under.
export const POWER_BI_REQUEST_TYPE = "PowerBIReport";

// Page size that stands in for "no limit" when a screen needs every report at once.
export const ALL_REPORTS_LIMIT = 1000;

export const ALL_ACTIVE_REPORTS_PAYLOAD = { filters: [], page: 1, limit: ALL_REPORTS_LIMIT, company_name: "All", is_active: true };

// Users of one role listed in an assignment panel; the backend's maximum page size.
export const ROLE_USERS_LIMIT = 200;

export const USER_SEARCH_LIMIT = 50;

export const SAVE_REDIRECT_DELAY_MS = 1000;
// Longer than SAVE_REDIRECT_DELAY_MS so a "saved, but…" warning can be read before leaving the page.
export const SAVE_WARNING_REDIRECT_DELAY_MS = 4000;

// Manage User Access popup width, matching the shared modal's "sm" size (scrollable modals ignore size).
export const MANAGE_ACCESS_MODAL_MAX_WIDTH = 600;

